import { Component, inject } from '@angular/core';
import { ErrorStore } from '../store/error.store';

@Component({
  selector: 'app-sandbox',
  imports: [],
  templateUrl: './sandbox.html',
  styleUrl: './sandbox.scss',
})
export class Sandbox {
    private _errorStore = inject(ErrorStore);

    protected errors = this._errorStore.errors;
}
